import OrthographicCamera from '../cameras/OrthographicCamera';
import Renderer from '../Renderer';
import Light from './Light';
import RenderTarget from '../RenderTarget';

import Vector3 from '../../math/Vector3';
import Matrix4x4 from '../../math/Matrix4x4';
import Camera from '../cameras/Camera3D';

/// #if DEVELOPMENT
import debugRender from '../debugRender';
/// #endif DEVELOPMENT

// const DEFAULT_DIRECTION = new Vector3(-2, -1, -0.5).normalize();
const DEFAULT_DIRECTION = new Vector3(-2, -2, -2).normalize();
// const DEFAULT_DIRECTION = new Vector3(0, 0, -1).normalize();

// const shadowMapFilteringProgram = {
// 	// Properties general to class inheriting from Object3D
// 	binder: null,
// 	fragmentShaderId: 'depthTextureBlur',
// 	vertexShaderId: 'filter',
// 	fragmentShader: require('../shaders/fragment/depthTextureBlur.frag'),
// 	vertexShader: require('../shaders/vertex/filter.vert'),
// 	uniformIds: ['uTexture', 'uPixelDimension'],
// 	attributeIds: ['aVertexPosition', 'aUV'],

// 	// Properties specific (but non-exclusive) to this class
// 	textureIndexes: { uTexture: 0 }
// };

// const sortObject = OrthographicCamera.prototype._sortObject;
export default class DirectionalLight extends Light {

	camera: OrthographicCamera;
	direction: Vector3;
	castShadow: boolean;

	private _shadowMapWidth: number;
	private _shadowMapHeight: number;

	shadowMapVPMatrix: Matrix4x4;
	shadowMap: RenderTarget;
	// shadowMap2: RenderTarget;

	constructor (direction: Vector3 = DEFAULT_DIRECTION) {
		super();

		this.camera = new OrthographicCamera();

		this.castShadow = false;

		this.direction = direction;

		this._shadowMapWidth  = 1024;
		this._shadowMapHeight = 1024;

		this.shadowMapVPMatrix = new Matrix4x4();

		this.shadowMap = new RenderTarget(this._shadowMapWidth, this._shadowMapHeight);

		// TODO: figure out if necessary
		const shadowMapClearColor = this.shadowMap.frameBuffer.clearColor;
		shadowMapClearColor.r = 1.0;
		shadowMapClearColor.g = 0.99;
		shadowMapClearColor.b = 1.0;
		shadowMapClearColor.a = 0.99;

		// this.shadowMap2 = new RenderTarget(Math.floor(this._shadowMapWidth * 0.8), Math.floor(this._shadowMapHeight * 0.8));
	}

	updateLight () {
		super.updateLight();
		this.direction.normalize();
	}

	renderShadowMap (renderer: Renderer, displayLists, camera: Camera) {
		// Setting position of the directional light
		this.camera.encloseCameraFrustum(camera, this.direction);
		// if (Math.random() < 0.1) {
		// 	console.error('enclosed', this.camera._near, this.camera._far, this.camera.height)
		// 	console.error('position', this.camera.position)
		// }

		// Setting up the view projection matrix
		this.camera.updateView(1, 1);

		// TODO: figure out why the +0.5 and *0.5
		const viewProjection = this.camera._aspectViewProjectionMatrix;
		this.shadowMapVPMatrix.set(viewProjection).multiplyScalar(0.5);
		const shadowMVPMatrixArray = this.shadowMapVPMatrix.getMatrixArray();
		shadowMVPMatrixArray[12] += 0.5;
		shadowMVPMatrixArray[13] += 0.5;
		shadowMVPMatrixArray[14] += 0.5;

		// if (Math.random() < 0.1) {
		// 	console.error('shadowMVPMatrixArray', shadowMVPMatrixArray)
		// }

		// Rendering shadow map
		renderer.useFrameBuffer(this.shadowMap.frameBuffer);
		this.shadowMap.clear(renderer);

		const gl = renderer.gl;

		const viewProjectionMatrix = viewProjection.getMatrixArray();
		function renderObject (object: any) {
			if (object.castShadow === false) {
				return;
			}

			const shader = object.shaders.depth;
			const programChanged = renderer.setupProgram(shader, object.textureSet.set, null);
			const program = shader.program;
			const uniforms = program.uniforms;
			if (programChanged) {
				gl.uniformMatrix4fv(uniforms.uVPMatrix, false, viewProjectionMatrix);
			}

			const modelMatrix = object.transform.globalTransform.getMatrixArray();
			gl.uniformMatrix4fv(uniforms.uMMatrix, false, modelMatrix);
			object.renderDepth(renderer, program);
		}

		gl.enable(gl.DEPTH_TEST);

		const opaqueList = displayLists.opaque;
		if (opaqueList.length > 0) {
			gl.depthMask(true);
			gl.enable(gl.CULL_FACE);
			gl.disable(gl.BLEND);
			for (let objectNode = opaqueList.first; objectNode !== null; objectNode = objectNode.next) {
				renderObject(objectNode.object);
			}
		}

		const transluscentList = displayLists.transluscent;
		if (transluscentList.length > 0) {
			gl.depthMask(false);
			gl.disable(gl.CULL_FACE);
			// gl.enable(gl.BLEND);
			// gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
			// TODO: reorder transluscent objects
			for (let objectNode = transluscentList.first; objectNode !== null; objectNode = objectNode.next) {
				renderObject(objectNode.object);
			}
		}

		renderer.popFrameBuffer();

		/// #if DEVELOPMENT
		// if (true) {
		// 	debugRender(renderer, this.shadowMap.textureSet);
		// }
		/// #endif DEVELOPMENT

		// TODO: try out blurring pass
		// // Applying anti-aliasing on the shadow map
		// renderer.useFrameBuffer(this.shadowMap.frameBuffer);
		// this.shadowMap.clear(renderer);

		// gl.uniform2f(shadowMapFilteringProgram.uPixelDimension, 1.0 / this._shadowMapWidth, 1.0 / this._shadowMapHeight);

		// gl.depthMask(false);
		// this.shadowMapSprite._render(shadowMapFilteringProgram);
		// gl.depthMask(true);

		// renderer.popFrameBuffer();
	}

	// delete () {
	// 	this.shadowMapRaw.delete();
	// 	this.shadowMap.delete();
	// }
}
